@let firmwares = (firmwares$ | async) ?? [];
@let isLoading = firmwareLoadingState() === LoadingState.LOADING;
@let isLoaded = firmwareLoadingState() === LoadingState.READY;

<section class="page-content page-viewport">
  <mon-page-toolbar
    titleTranslateKey="monitoring.menu.firmwares"
    [searchControl]="searchControl"
    searchPlaceholderTranslateKey="monitoring.firmware.dashboard.search"
    [actions]="toolbarActions"
    [selectedFiltersCount]="selectedFiltersCount"
    (actionClick)="onToolbarAction($event)"
  >
    <div
      toolbarFilters
      class="firmware__filters"
      [formGroup]="filterForm"
    >
      @if (canReadEquipmentModels()) {
        <mon-equipment-model-selector
          class="firmware__filter"
          [controlEntity]="getControl('models')"
          (selectionChange)="showSelectedModels($event)"
        />
      }
    </div>

    @if (isFilterActive) {
      <div
        toolbarSelectedFilters
        class="firmware__selected-filters"
      >
        <lib-button
          (click)="clearAllFilters()"
          class="chip chip--button"
          buttonStyle="danger"
          buttonSize="medium"
          buttonType="button"
        >
          <span> {{ 'monitoring.firmware.dashboard.clear-filters' | translate }} </span>
        </lib-button>

        @for (model of selectedModels; track model.id) {
          <lib-button
            (click)="deselectModel(model)"
            class="chip chip--button"
            buttonStyle="danger"
            buttonSize="medium"
            buttonType="button"
          >
            <lib-svg-icon
              icon="close"
              size="16"
            />
            <span> {{ model.name }} </span>
          </lib-button>
        }
      </div>
    }
  </mon-page-toolbar>

  <section class="page-content page-table">
    <lib-table
      [trCustomClass]="canEditFirmwareModels ? 'desktop-table-row--hoverable' : ''"
      [columns]="columns"
      [dataSource]="firmwares"
      [cellTemplates]="{
        name: nameTpl,
        modelCount: modelCountTpl,
        version: versionTpl,
        comment: commentTpl,
        uploadedBy: uploadedByTpl,
        uploadDate: uploadDateTpl,
        download: downloadTpl,
      }"
      [loaded]="isLoaded"
      [loading]="isLoading"
      (desktopRowClick)="onFirmwareAction(FirmwareAction.Edit, $event.id)"
    />

    <!-- пагинация -->
    @if (!(firmwares.length === 0 && currentPage() === 1)) {
      <lib-pagination
        [totalCount]="totalFirmwareCount()"
        [loading]="isLoading"
        [pageIndex]="currentPage()"
        [pageSize]="100"
        (paginationChange)="onPageChange($event)"
      ></lib-pagination>
    }
  </section>

  <!-- шаблоны ячеек -->
  <ng-template
    #nameTpl
    let-row="data"
  >
    <div class="firmware__cell">{{ asFirmware(row).name || '—' }}</div>
  </ng-template>

  <ng-template
    #modelCountTpl
    let-row="data"
  >
    <div class="firmware__cell">
      @if (asFirmware(row).equipmentModels) {
        {{ asFirmware(row).equipmentModels.length }}
      }
    </div>
  </ng-template>

  <ng-template
    #versionTpl
    let-row="data"
  >
    <div class="firmware__cell">{{ asFirmware(row).version || '—' }}</div>
  </ng-template>

  <ng-template
    #commentTpl
    let-row="data"
  >
    <div class="firmware__cell">{{ asFirmware(row).comment || '—' }}</div>
  </ng-template>

  <ng-template
    #uploadedByTpl
    let-row="data"
  >
    <div class="firmware__cell">
      {{ asFirmware(row).createdByName || '—' }}
    </div>
  </ng-template>

  <ng-template
    #uploadDateTpl
    let-row="data"
  >
    <div class="firmware__cell">
      <div>{{ asFirmware(row).createdDate | date: 'dd.MM.yyyy' : 'UTC' }}</div>
      <div class="firmware__cell-time">
        {{ asFirmware(row).createdDate | date: 'HH:mm:ss' : 'UTC' }}
        (UTC)
      </div>
    </div>
  </ng-template>

  <ng-template
    #downloadTpl
    let-row="data"
  >
    <div class="firmware__cell">
      <lib-icon-button
        [title]="'monitoring.firmware.download-firmware' | translate"
        class="suffix firmware__download"
        icon="download"
        [disabled]="isDownloadingFirmware()"
        [size]="20"
        (click)="onDownload(row, $event)"
      ></lib-icon-button>
    </div>
  </ng-template>
</section>
